export default __webpack_public_path__ + "static/media/money-icon.49d286af.png";